import { PropTypes } from 'prop-types';
import { TourProvider } from '@reactour/tour';

export const tourConfig = [
  {
    selector: '#sidebar-menu',
    content:
      'Welcome to the Voxel Readers! Here you can navigate through different sections of the application.',
  },
  {
    selector: '#dashboard',
    content:
      'This is your dashboard section where you can view overall statistics and reports.',
  },
  {
    selector: '.menu-side',
    content: 'Each menu item has an icon to help you identify its purpose.',
  },
  {
    selector: '.submenu',
    content: 'Click on menu items to expand them and see additional options.',
  },
  {
    selector: '.menu-arrow',
    content: 'Items with arrows contain sub-menus with more specific features.',
  },
  // {
  //   selector: '#patients',
  //   content: 'Manage all patient-related information and records here.'
  // },
  // {
  //   selector: '#users',
  //   content: 'Manage all users-related information and records here.'
  // },
  // {
  //   selector: '#branches',
  //   content: 'Manage all clinic branch information and records here.'
  // },
  {
    selector: '#cases',
    content: 'Manage all case-related information and records here.',
  },
  {
    selector: '#revenue',
    content: 'Manage all revenue-related information and records here.',
  },
  {
    selector: '#account-profile',
    content: 'Manage your profile here.',
  },
];

export const TourWrapper = ({ children }) => {
  return (
    <TourProvider
      steps={tourConfig}
      showNavigation={true}
      showBadge={false}
      styles={{
        popover: (base) => ({
          ...base,
          '--reactour-accent': '#00d3c7',
          borderRadius: 10,
        }),
        badge: (base) => ({
          ...base,
          background: '#00d3c7',
        }),
        controls: (base) => ({
          ...base,
          marginTop: 20,
        }),
      }}
    >
      {children}
    </TourProvider>
  );
};
TourWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
